export const GUIDE_REQUEST_RESPONSE_LOADING = 'GUIDE_REQUEST_RESPONSE_LOADING';

export const guideRequestResponseLoading = (loading) => {
    return {
        type: GUIDE_REQUEST_RESPONSE_LOADING,
        loading
    };
}